import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaOfferRequestsCommon, schemaOfferRequestsEuropace } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    requestId: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};
export const schemaLoanRequestResolver_GetOfferRequestState = z.object({
    failedReason: schemaOfferRequestsEuropace.shape.failedReason.nullable(),
    state: schemaOfferRequestsCommon.shape.state.nullable(),
});

export type SchemaLoanRequestResolver_GetOfferRequestState = z.infer<
    typeof schemaLoanRequestResolver_GetOfferRequestState
>;

export type LoanRequestResolver_GetOfferRequestState = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOfferRequestState
>;
